import { S3_presignedPost } from "./type_defs";

/*
 * requests server for presigned post to allow uploading of photo w/ name filename to s3, save under photos for review specified with reviewID
 */
export const getS3url_reviewImg = async (filename:string,reviewID:string) => {
	let success:boolean = false;
	let response:S3_presignedPost;
	let errMsg:string;

	await $.ajax({
		type: "get",
		url: `/reqS3url_reviewImg?filename=${filename}&reviewID=${reviewID}`,
		contentType: "application/x-www-form-urlencoded",
		dataType: "json",
		success: function(data) {
			success = true;
			response = data;
		},
		error: function(xhr,err,exception) {
			success = false;
			errMsg = err;
		}
	});

	return new Promise<S3_presignedPost>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const getS3url_campPhoto = async (filename:string,campID?:string|undefined,campName?:string|undefined) => {
	let success:boolean = false;
	let response:S3_presignedPost;
	let errMsg:string;
	if(campID != undefined) {
		await $.ajax({
			type: "get",
			url: `/reqS3url_campImg?filename=${filename}&campID=${campID}`,
			contentType: "application/x-www-form-urlencoded",
			dataType: "json",
			success: function(data) {
				success = true;
				response = data;
				$("#editCG_imageCounter_wrapper").removeClass("d-none");
				//get value of addCG_imageCounter and convert it to a number
				let editCG_imageCounter = parseInt($("#editCG_imageCounter").text() as string);
				//iterate upon the value of addCG_imageCounter by 1 and set that new value to be addCG_imageCounter's new value
				$("#editCG_imageCounter").text(editCG_imageCounter+1);
			},
			error: function(xhr,err,exception) {
				success = false;
				errMsg = err;
			}
		});
	} else if (campName != undefined) {
		await $.ajax({
			type: "get",
			url: `/reqS3url_campImg?filename=${filename}&campName=${campName}`,
			contentType: "application/x-www-form-urlencoded",
			dataType: "json",
			success: function(data) {
				success = true;
				response = data;
				$("#addCG_imageCounter_wrapper").removeClass("d-none");
				//get value of addCG_imageCounter and convert it to a number
				let addCG_imageCounter = parseInt($("#addCG_imageCounter").text() as string);
				//iterate upon the value of addCG_imageCounter by 1 and set that new value to be addCG_imageCounter's new value
				$("#addCG_imageCounter").text(addCG_imageCounter+1);
			},
			error: function(xhr,err,exception) {
				success = false;
				errMsg = err;
			}
		});
	} else {
		//throw error to set campid OR campname
		console.error("error: campID or campName must be defined");
		alert("error: campID or campName must be defined");
	}
	return new Promise<S3_presignedPost>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};


export const getS3url_ambassadorQR = async (filename:string,reviewID:string) => {
	let success:boolean = false;
	let response:S3_presignedPost;
	let errMsg:string;

	await $.ajax({
		type: "get",
		url: `/{ENV}/referallQR/<uID>.png.webp`,
		contentType: "application/x-www-form-urlencoded",
		dataType: "json",
		success: function(data) {
			success = true;
			response = data;
		},
		error: function(xhr,err,exception) {
			success = false;
			errMsg = err;
		}
	});

	return new Promise<S3_presignedPost>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};